import { connect } from 'react-redux';
import { requestHotelSearch, viewBrowseHotel, requestBrandOptions, requestBrandGroups } from '../modules/hotels';

import BrowseHotels from '../components/BrowseHotels';

const mapDispatchToProps = {
  requestHotelSearch,
  viewBrowseHotel,
  requestBrandOptions,
  requestBrandGroups,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.search.isFetching,
  needFetch: state.hotels.search.needFetch,
  hasError: state.hotels.search.hasError,
  hotels: state.hotels.search.hotels,
  perms: state.auth.perms,
  id: ownProps.params.id,
  brands: state.hotels.brands,
  brandGroups: state.hotels.brandGroups,
});

export default connect(mapStateToProps, mapDispatchToProps)(BrowseHotels);



// WEBPACK FOOTER //
// src/routes/hotels/containers/BrowseHotelsContainer.js